import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  message: '',
  validation: {
    firstName: { isValid: false, hasError: false },
    lastName: { isValid: true, hasError: false },
    email: { isValid: false, hasError: false },
    message: { isValid: false, hasError: false },
  }
}

const supportFormSlice = createSlice({
  name: 'supportForm',
  initialState,
  reducers: {
    setfirstName: (state, action) => {
      state.firstName = action.payload
    },
    setlastName: (state, action) => {
      state.lastName = action.payload
    },
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setMessage: (state, action) => {
      state.message = action.payload
    },
    setFullsupport: (state, action) => {
      state.firstName = action.payload.firstName
      state.lastName = action.payload.lastName
      state.email = action.payload.email
      state.message = action.payload.message
    },
    resetSupportForm: () => initialState,
    setValidation: (state, action) => {
      const { field, isValid, hasError } = action.payload
      if (state.validation[field]) {
        state.validation[field] = { isValid, hasError }
      }
    }
  }
})

export const {
  setfirstName, setlastName, setEmail, setMessage, setFullsupport, resetSupportForm, setValidation
} = supportFormSlice.actions
export default supportFormSlice.reducer
